export const LIVE_CHAT_STATUS_ONLINE = 'online';
export const LIVE_CHAT_STATUS_OFFLINE = 'offline';
export const LIVE_CHAT_STATUS_AWAY = 'away';
export const LIVE_CHAT_PROVIDER_TAWK = 'tawk';
export const LIVE_CHAT_PROVIDER_INTERCOM = 'intercom';
export const LIVE_CHAT_PROVIDER_HUBSPOT = 'hubspot';
